import { CircularProgress } from "@mui/material";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function PartnersSkeleton() {
  const customHeight = 170;

  const skeletonBoxStyle = {
    backgroundColor: "#fff",
    borderRadius: "2px",
    height: "250px",
    width: "100%",
    maxWidth: "150px", // This limits max width on larger screens
  };

  return (
    <div className="d-flex flex-column min-vh-100 gap-4 p-3 align-items-center">
      {/* You can uncomment the heading part if needed */}
      {/* <div style={{ width: "100%", maxWidth: "600px" }}>
        <Skeleton
          baseColor="#ddd"
          highlightColor="#f5deb3"
          width="100%"
          height={40}
        />
      </div> */}

      {[...Array(2)].map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 w-100"
        >
          {[...Array(5)].map((_, colIndex) => (
            <div
              key={colIndex}
              className="w-100 d-md-flex justify-content-md-center"
              style={{ maxWidth: "100%" }}
            >
              <div
                style={{
                  ...skeletonBoxStyle,
                  width: "100%",
                  maxWidth: "300px",
                }}
              >
                <Skeleton
                  baseColor="#ddd"
                  highlightColor="#f5deb3"
                  width="100%"
                  height={customHeight}
                />
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
